
















import {highestKey} from '@/utils';
import {fromPairs} from 'lodash-es';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import Control from './Control';
import ReconstructionControl from './ReconstructionControl.vue';
import {Reconstruction} from './values';

interface Values { [key: number]: (Reconstruction | null); }

@Component({
    components: {ReconstructionControl},
})
export default class ReconstructionListControl extends Mixins<Control<Reconstruction[]>>(Control) {
    @Prop({type: Array, required: true})
    public readonly typeOptions: string[];

    @Prop({type: Array, required: true})
    public readonly extentOptions: string[];

    public reconstructions: Values = {};

    public addReconstruction(): void {
        const reconstructions = Object.assign({}, this.reconstructions);

        reconstructions[highestKey(reconstructions) + 1] = null;

        this.reconstructions = reconstructions;
    }

    public removeReconstruction(key: number): void {
        const reconstructions = Object.assign({}, this.reconstructions);

        delete reconstructions[key];

        this.reconstructions = reconstructions;
    }

    protected mounted(): void {
        const value = this.value;

        if (value === null) {
            return;
        }

        this.reconstructions = fromPairs([...value.entries()]);
    }

    protected getValue(): Reconstruction[] | null {
        return Object.values(this.reconstructions).filter(r => r !== null);
    }

    protected validateCurrentValue(): boolean {
        return Object.values(this.reconstructions).every(r => r !== null);
    }

    @Watch('reconstructions', {deep: true})
    private valueChanged(): void {
        this.updateValue();
    }
}
